export default __webpack_public_path__ + "static/certificado-mb-7fd28b9266c486611f54fde9ea762718.pdf";